import { useReducer } from 'react';
import { Action, DrinksShape } from '../types/DrinksReducer';

const initState = { largeBeer: 0, smallBeer: 0, wine: 0, shot: 0 };

const useDrinks = () =>
    useReducer((state: DrinksShape, action: Action) => {
        switch (action.type) {
            case 'add':
                return { ...state, [action.alcohol]: state[action.alcohol] + 1 };
            case 'remove': {
                if (state[action.alcohol] > 0) {
                    return {
                        ...state,
                        [action.alcohol]: state[action.alcohol] - 1,
                    };
                }
                break;
            }
            case 'reset': {
                return initState;
            }
        }
        return state;
    }, initState);

export default useDrinks;
